<div class="mat-table-global">
  <table
    [dataSource]="dataSource"
    mat-table
    matSort
    matTableResponsive
    multiTemplateDataRows>
    <ng-container matColumnDef="paymentStatus">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element">
        <mat-chip disableRipple [ngClass]="element.paymentStatus">{{
          element.paymentStatus
        }}</mat-chip>
      </td>
    </ng-container>

    <ng-container matColumnDef="invoiceNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice ID</th>
      <td mat-cell *matCellDef="let element">{{ element.invoiceNumber }}</td>
    </ng-container>

    <ng-container matColumnDef="invoiceDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
      <td mat-cell *matCellDef="let element">
        {{ element.invoiceDate | date: 'MM/dd/yyyy' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
      <td mat-cell *matCellDef="let element">{{ element.total | currency }}</td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th class="action-column text-center" mat-header-cell *matHeaderCellDef>
        Action
      </th>
      <td class="action-column-details" mat-cell *matCellDef="let element">
        <div class="row" style="justify-content: flex-end">
          <div
            class="action-icon-container visibility text-right text-md-center col-4 col-md-6"
            (click)="onInvoiceSelect(element.billingAccount, element.id)">
            <img src="../assets/images/visibility.svg" alt="View" />
          </div>
          <div
            class="action-icon-container pay text-right text-md-center col-4 col-md-6"
            [class.disabled]="
              !(element.rtsPaymentLink?.length && element.total > 0) ||
              element.paymentStatus === 'Paid'
            "
            (click)="onInvoicePay(element)">
            <img
              [src]="
                element.rtsPaymentLink?.length && element.total > 0
                  ? element.paymentStatus !== 'Paid'
                    ? '../assets/images/credit_card.svg'
                    : '../assets/images/credit_card_disabled.svg'
                  : '../assets/images/credit_card_disabled.svg'
              "
              alt="View" />
          </div>
        </div>
      </td>
    </ng-container>

    <tr
      class="table-header-row"
      mat-header-row
      *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let element; columns: displayedColumns"
      class="table-data-row"></tr>
  </table>

  <mat-paginator
    [pageSizeOptions]="[10, 20, 30]"
    showFirstLastButtons></mat-paginator>
</div>
